export default "__VITE_ASSET__tkoshpde__"